import React, { useRef, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTracker } from "@dpdgroupuk/react-event-tracker";

import RouteManagement from "./RouteManagement";
import ModalControlled from "../../../components/ModalControlled";
import SelectMultipleRouteStops from "../../../components/modals/SelectMultipleRouteStops";
import { wrapPromise } from "../../../utils/promise";
import StopList from "./StopList";
import DriverRequests from "../../../components/modals/DriverRequests";
import PickupStops from "../../../components/modals/PickupStops";
import stopTypes from "../../../enums/stopTypes";
import { updateSelectedStops } from "../../../store/actions/ui/routeDetail";
import ScheduleRoute from "../../../features/scheduleRoute";
import modalTypes from "../../../enums/modalTypes";
import { ROUTE_DETAIL } from "../../../constants/analytics";

const RouteDetailContainer = ({ route, handleBackClick }) => {
  const dispatch = useDispatch();
  const selectMultipleRouteStopsModalRef = useRef();
  const tracker = useTracker();

  const requestModalRef = useRef();
  const pickupStopsModalRef = useRef();

  const handleSelectMultipleRouteStops = useCallback(async () => {
    const [result, canceled] = await wrapPromise(
      selectMultipleRouteStopsModalRef.current.showModal({
        routeStops: route.stop ?? [],
      })
    );

    if (canceled) return;

    const { from, to } = result;
    const [fromNormalized, toNormalized] = from <= to ? [from, to] : [to, from];

    dispatch(
      updateSelectedStops(
        route.stop
          .slice(fromNormalized, toNormalized + 1)
          .map(({ stopId }) => stopId)
      )
    );
  }, [route.stop, dispatch]);

  useEffect(() => {
    tracker.logEvent(ROUTE_DETAIL.LOAD);
  }, [tracker]);

  const onSelectStopRequests = useCallback((stop) => {
    if (stop.type === stopTypes.shop && stop.requests.length > 1) {
      return wrapPromise(pickupStopsModalRef.current.showModal());
    }

    return wrapPromise(
      requestModalRef.current.showModal({
        stop,
      })
    );
  }, []);

  return (
    <>
      <RouteManagement
        onSelectMultipleClick={handleSelectMultipleRouteStops}
        handleBackClick={handleBackClick}
        onParcelRequestClick={onSelectStopRequests}
      />
      <StopList onSelectStopRequests={onSelectStopRequests} />
      <ScheduleRoute />
      <ModalControlled
        ref={selectMultipleRouteStopsModalRef}
        Component={SelectMultipleRouteStops}
        type={modalTypes.RIGHT_DRAWER}
      />
      <ModalControlled
        ref={requestModalRef}
        Component={DriverRequests}
        route={route}
        renderWhenOpen
        type={modalTypes.RIGHT_DRAWER}
      />
      <ModalControlled ref={pickupStopsModalRef} Component={PickupStops} />
    </>
  );
};

RouteDetailContainer.propTypes = {
  route: PropTypes.object.isRequired,
  handleBackClick: PropTypes.func.isRequired,
};

export default RouteDetailContainer;
